import { useMutation, useQuery } from '@tanstack/react-query';
import { addComment, getComments } from '../loanCommentService';
import type { GetLoanApplicationCommentsParams } from '../schemas/loanServiceSchemas/getLoanApplicationCommentsParams';
import type { LoanApplicationCommentPage } from '../schemas/loanServiceSchemas/loanApplicationCommentPage';

/**
 * Hook for adding comments to loan applications
 */
export const useAddComment = <TError = Error, TContext = unknown>(
  options?: any
) => {
  return useMutation<Awaited<ReturnType<typeof addComment>>, TError, { loanApplicationId: string; comment: string; createdBy?: string }, TContext>({
    mutationFn: ({ loanApplicationId, comment, createdBy }) => addComment(loanApplicationId, comment, createdBy),
    ...options,
  });
};

/**
 * Hook for retrieving comments for loan applications
 */
export const useGetComments = <TError = Error>(
  loanApplicationId: string,
  params?: GetLoanApplicationCommentsParams,
  options?: any
) => {
  return useQuery<LoanApplicationCommentPage, TError>({
    queryKey: ['loan-comments', loanApplicationId, params],
    queryFn: () => getComments(loanApplicationId, params),
    ...options,
  });
};